import instance from "../api-provider";
import handleError from "../handleError";

export const updatePracticeAnsweringSettings = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/updatePracticeAnsweringSettings",
      method: "POST",
      addPracticeId: false,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const addPracticeAnsweringSettings = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/addPracticeAnsweringSettings",
      method: "POST",
      addPracticeId: false,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPracticeAnsweringSettings = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getPracticeAnsweringSettings",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getUserOrgDetails = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getUserOrgDetails",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getTimesheetDetails = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getTimesheetDetails",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getTimesheetListByUser = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getTimesheetListByUser",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getMyTeamTimesheetList = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getMyTeamTimesheetList",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getOrgProjectTasks = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getOrgProjectTasks",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getAnsweringSettingsMaster = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getAnsweringSettingsMaster",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const addPracticeClosure = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/addPracticeClosure",
      method: "POST",
      addPracticeId: false,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const submitTimesheet = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/submitTimesheet",
      method: "POST",
      addPracticeId: false,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPracticeClosure = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getPracticeClosure",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updatePracticeClosure = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/updatePracticeClosure",
      method: "POST",
      addPracticeId: false,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateTimesheetStatus = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/updateTimesheetStatus",
      method: "POST",
      addPracticeId: false,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const addPracticeOfficeHours = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/addPracticeOfficeHours",
      method: "POST",
      addPracticeId: false,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPracticeOfficeHours = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getPracticeOfficeHours",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updatePracticeOfficeHours = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/updatePracticeOfficeHours",
      method: "POST",
      addPracticeId: false,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const addProvider = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/addProvider",
      method: "POST",
      addPracticeId: false,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getProviderList = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getProviders",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateProvider = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/updateProvider",
      method: "POST",
      addPracticeId: false,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const addPracticeLocation = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/addPracticeLocation",
      method: "POST",
      addPracticeId: false,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const editPractice = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/editPractice",
      method: "POST",
      addPracticeId: false,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updatePracticeInfo = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/updatePracticeInfo",
      method: "POST",
      addPracticeId: false,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPracticeInfo = async (payload, token) => {
  try {
    let response = await instance({
      url: "/provider/getPracticeInfo",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getAppointmentCount = async (payload, token) => {
  try {
    let response = await instance({
      // url: "/appointment/getAppointmentCount",
      url: "/provider/getAppointmentsCount",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    return "ERROR";
  }
};

// export const getProviderAppointments = async (payload) => {
//   try {
//     let response = await instance({
//       url: "/appointment/getProviderAppointments",
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: payload,
//     });
//     return response.data;
//   } catch (error) {
//     return "ERROR";
//   }
// };

// export const getProviderListByAdmin = async (uuid) => {
//   try {
//     let response = await instance({
//       url: "/provider/getProviderListByAdmin",
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: { uuid },
//     });
//     return response.data;
//   } catch (error) {
//     return "ERROR";
//   }
// };

// for payload
// export const getTodaysStartEndDateTime = () => {
//   const today = new Date();
//   const month = today.getMonth() + 1;
//   const date = today.getDate();
//   const year = today.getFullYear();
//   return {
//     todaysStartDateTime: `${year}-${month}-${date}T00:00:00+0000`,
//     todaysEndDateTime: `${year}-${month}-${date}T23:59:59+0000`,
//   };
// };
